import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function ReportBook({ color = 'icon.white', stroke = '1.5', fill = 'transparent', ...props }) {
  return (
    <IconBase
      viewBox='0 0 24 24'
      fill='none'
      {...props}
    >
      <Path
        d='
          M15 8.99219
          H17
        '
        stroke={color}
        strokeWidth={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        d='M7 16.9844H9'
        stroke={color}
        strokeWidth={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        d='M12 16.9844H17'
        stroke={color}
        strokeWidth={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        d='
          M19 4
          C20.105 4 21 4.89434 21 5.99853
          V18.989
          C21 20.0932 20.105 20.9875 19 20.9875
          H5C3.895 20.9875 3 20.0932 3 18.989
          V5.99853
          C3 4.89434 3.895 4 5 4
        '
        stroke={color}
        strokeWidth={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        d='M7 12.9922H9'
        stroke={color}
        strokeWidth={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        d='M12 12.9922H17'
        stroke={color}
        strokeWidth={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='
            M10 3H8
            C7.448 3 7 3.44767 7 3.99927
            V8.9956
            L9 7.99633
            L11 8.9956
            V3.99927
            C11 3.44767 10.552 3 10 3Z
        '
        stroke={color}
        strokeWidth={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        d='M5 4H7'
        stroke={color}
        strokeWidth={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        d='M11 4H19'
        stroke={color}
        strokeWidth={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
    </IconBase>
  )
}

ReportBook.propTypes = {
  color: PropTypes.string,
  stroke: PropTypes.string,
  fill: PropTypes.string,
}

export default ReportBook
